"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_easy_swipe_1 = __importDefault(require("react-easy-swipe"));
require("../../css/carousel.css");
function Carousel({ data, time, width, height, captionStyle, slideNumberStyle, radius, slideNumber, style, captionPosition, dots, automatic, pauseIconColor, pauseIconSize, slideBackgroundColor, slideImageFit, thumbnails, thumbnailWidth, showNavBtn = true, }) {
    //Initialize States
    const [slide, setSlide] = (0, react_1.useState)(0);
    const [isPaused, setIsPaused] = (0, react_1.useState)(false);
    const [change, setChange] = (0, react_1.useState)(false);
    //Function to change slide
    const addSlide = (n) => {
        if (slide + n >= data.length)
            setSlide(0);
        else if (slide + n < 0)
            setSlide(data.length - 1);
        else
            setSlide(slide + n);
    };
    //Start the automatic change of slide
    (0, react_1.useEffect)(() => {
        if (automatic) {
            var index = slide;
            const interval = setInterval(() => {
                if (!isPaused) {
                    setSlide(index);
                    index++;
                    if (index >= data.length)
                        index = 0;
                    if (index < 0)
                        index = data.length - 1;
                }
            }, time ? time : 2000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [isPaused, change]);
    function scrollTo(el) {
        const elLeft = el.offsetLeft + el.offsetWidth;
        const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
        // check if element not in view
        if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
            el.parentNode.scroll({ left: elLeft - elParentLeft, behavior: "smooth" });
        }
        else if (elLeft <= el.parentNode.offsetLeft + el.parentNode.scrollLeft) {
            el.parentNode.scroll({
                left: el.offsetLeft - el.parentNode.offsetLeft,
                behavior: "smooth",
            });
        }
    }
    //Listens to slide state changes
    (0, react_1.useEffect)(() => {
        var slides = document.getElementsByClassName("carousel-item");
        var dotList = document.getElementsByClassName("dot");
        var slideIndex = slide;
        var i;
        for (i = 0; i < data.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dotList.length; i++) {
            dotList[i].className = dotList[i].className.replace(" active", "");
        }
        //If thumbnails are enabled
        if (thumbnails) {
            var thumbnailsArray = document.getElementsByClassName("thumbnail");
            for (i = 0; i < thumbnailsArray.length; i++) {
                thumbnailsArray[i].className = thumbnailsArray[i].className.replace(" active-thumbnail", "");
            }
            if (thumbnailsArray[slideIndex] !== undefined)
                thumbnailsArray[slideIndex].className += " active-thumbnail";
            scrollTo(document.getElementById(`thumbnail-${slideIndex}`));
        }
        if (slides[slideIndex] !== undefined)
            slides[slideIndex].style.display = "block";
        if (dotList[slideIndex] !== undefined)
            dotList[slideIndex].className += " active";
    }, [slide, isPaused]);
    return (react_1.default.createElement("div", { style: style, className: "box" },
        react_1.default.createElement("div", { style: {
                maxWidth: width ? width : "600px",
                maxHeight: height ? height : "400px",
            } },
            react_1.default.createElement(react_easy_swipe_1.default, { onSwipeRight: () => {
                    addSlide(-1);
                    setChange(!change);
                }, onSwipeLeft: () => {
                    addSlide(1);
                    setChange(!change);
                } },
                react_1.default.createElement("div", { className: "carousel-container", style: {
                        maxWidth: width ? width : "600px",
                        height: height ? height : "400px",
                        backgroundColor: slideBackgroundColor
                            ? slideBackgroundColor
                            : "darkgrey",
                        borderRadius: radius,
                    } },
                    data.map((item, index) => {
                        return (react_1.default.createElement("div", { className: "carousel-item carousel-item-fade", style: {
                                maxWidth: width ? width : "600px",
                                maxHeight: height ? height : "400px",
                            }, onMouseDown: () => {
                                automatic && setIsPaused(true);
                            }, onMouseUp: () => {
                                automatic && setIsPaused(false);
                            }, onMouseLeave: () => {
                                automatic && setIsPaused(false);
                            }, onTouchStart: () => {
                                automatic && setIsPaused(true);
                            }, onTouchEnd: () => {
                                automatic && setIsPaused(false);
                            }, key: item.id },
                            slideNumber && (react_1.default.createElement("div", { className: "slide-number", style: slideNumberStyle },
                                index + 1,
                                " / ",
                                data.length)),
                            react_1.default.createElement("img", { src: item.image, alt: item.caption, className: "carousel-image", style: {
                                    borderRadius: radius,
                                    objectFit: slideImageFit ? slideImageFit : "cover"
                                } }),
                            isPaused && (react_1.default.createElement("div", { className: "pause-icon pause", style: {
                                    color: pauseIconColor ? pauseIconColor : "white",
                                    fontSize: pauseIconSize ? pauseIconSize : "40px",
                                } }, "II")),
                            react_1.default.createElement("div", { className: `carousel-caption-${captionPosition ? captionPosition : "bottom"}`, style: captionStyle, dangerouslySetInnerHTML: { __html: item.caption } })));
                    }),
                    showNavBtn && (react_1.default.createElement("a", { className: "prev", onClick: () => {
                            addSlide(-1);
                            setChange(!change);
                        } }, "\u276E")),
                    showNavBtn && (react_1.default.createElement("a", { className: "next", onClick: () => {
                            addSlide(1);
                            setChange(!change);
                        } }, "\u276F")),
                    dots && (react_1.default.createElement("div", { className: "dots" }, data.map((item, index) => {
                        return (react_1.default.createElement("span", { className: "dot", key: item.id, onClick: () => {
                                setSlide(index);
                                setChange(!change);
                            } }));
                    })))))),
        thumbnails && (react_1.default.createElement("div", { className: "thumbnails", id: "thumbnail-div", style: { maxWidth: width } }, data.map((item, index) => {
            return (react_1.default.createElement("img", { width: thumbnailWidth ? thumbnailWidth : "100px", src: item.image, alt: item.caption, className: "thumbnail", id: `thumbnail-${index}`, key: item.id, onClick: () => {
                    setSlide(index);
                    setChange(!change);
                } }));
        })))));
}
exports.default = Carousel;
